import React, { memo, useEffect } from 'react'
import classNames from 'classnames'
import filter from 'ramda/src/filter'
import pluck from 'ramda/src/pluck'
import contains from 'ramda/src/contains'
import prop from 'ramda/src/prop'
import isNil from 'ramda/src/isNil'
import dropLast from 'ramda/src/dropLast'
import onSelectHandler from 'root/src/client/logic/app/handlers/onSelectHandler'
import useDebounce from 'root/src/client/web/hooks/useDebounce'

export default memo(({ props: {
	input, classes, placeholder, setListOpen, setLoading,
	setOptions, loadOptions, value, onSelect,
	isMulti, error, locked, listOpen, activeOption, debounceDelay = 0,
	inputHeight, setCursor, setHasMore, textInput, setTextInput, fieldTheme,
} }) => {
	const debouncedInput = useDebounce(textInput, debounceDelay)
	useEffect(() => {
		if (!textInput) {
			(async () => setOptions([]))()
		} else {
			(async () => {
				setListOpen(false)
				setLoading(true)
				const loadOptionsResult = await loadOptions(debouncedInput)
				const filteredOptions = isMulti ? filter(
					({ value: optionValue }) => !contains(optionValue, pluck('value', value)), loadOptionsResult,
				) : loadOptionsResult
				setLoading(false)
				setListOpen(true)
				setOptions(filteredOptions)
				if (!isNil(filteredOptions[0])) {
					setHasMore(!!filteredOptions[0].cursor)
					setCursor(filteredOptions[0].cursor)
				}
			})()
		}
	}, [debouncedInput])

	return (
		<input
			ref={input}
			disabled={locked}
			className={classNames(
				classes.ddInputHeader, {
					[classes.ddInputHeaderError]: error,
					[classes.ddInputHeaderLocked]: locked,
				},
			)}
			style={{ height: inputHeight, backgroundColor: fieldTheme?.backgroundColor }}
			placeholder={prop('length', value) > 0 ? '' : placeholder}
			onKeyDown={(e) => {
				if (listOpen) {
					if (e.keyCode === 13) {
						e.preventDefault()
						onSelectHandler(activeOption, onSelect, setListOpen, isMulti, value, input)()
					}
					if (e.keyCode === 8 && !input.current.value && value) {
						onSelect(dropLast(1, value))
					}
				}
			}}
			onChange={e => setTextInput(e.target.value)}
		/>
	)
})
